module.exports = __webpack_public_path__ + "img/parent-node.25f1b211.svg";